import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

import { PopupContext } from "../../context/PopupProvider";
import MyButton from "../../components/MyButton";
import MyTextField from "../../components/inputs/MyTextField";
import { SiteContext } from "../../context/SiteProvider";

const EnterWriterPasswordDialog = ({
  type = "board-item",
  params,
  permission = "view",
  redirect = () => {},
  mutation,
  onAction = () => {},
}) => {
  const { t } = useTranslation();
  const { closePopup } = useContext(PopupContext);
  const { setLoadingScreen } = useContext(SiteContext);

  const initValues = {
    writerPassword: "",
  };

  const validationSchema = yup.object({
    writerPassword: yup.string().required("필수 입력 항목입니다."),
  });

  const methods = useForm({
    defaultValues: initValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    setLoadingScreen(true);

    mutation.mutate(
      {
        ...params,
        payload: { writerPassword: data.writerPassword },
      },
      {
        onSuccess: (res) => {
          if (res?.privateViewToken || res?.anonymousEditToken) {
            if (permission === "view" && redirect) {
              redirect(`?privateViewToken=${res.privateViewToken}`);
            }
            closePopup();
            onAction({
              ...res,
              payload: { writerPassword: data.writerPassword },
            });
          }
        },
        onError: (err) => {
          if (err.data.code === "AUTHENTICATION_FAILURE") {
            methods.setError("writerPassword", {
              message: "비밀번호가 일치하지 않습니다.",
            });
            return;
          }
          alert("인증 실패.");
        },
        onSettled: () => {
          setLoadingScreen(false);
        },
      }
    );
  };

  return (
    <div className="rounded-2xl overflow-hidden bg-white">
      <h2 className="bg-primary text-center text-lg text-white font-semibold py-4">
        비밀번호 입력
      </h2>
      <FormProvider {...methods}>
        <form
          className="md:p-10 p-6 flex flex-col gap-4 items-center"
          onSubmit={methods.handleSubmit(onSubmit)}
        >
          <div className="flex items-center justify-center gap-2">
            <img src="/assets/img/lock2.png" alt="" className="w-10 h-10" />

            <div>
              {permission === "view" && (
                <p>{type !== "comment" ? "이 글은 비밀글입니다." : ""}</p>
              )}
              <p className="font-semibold">
                {type !== "comment"
                  ? "게시글 작성 시 설정한 비밀번호를 입력해주세요."
                  : "댓글 작성 시 설정한 비밀번호를 입력해주세요."}
              </p>
            </div>
          </div>

          {permission === "delete" && (
            <p className="text-error">
              <b className="font-semibold text-error">'확인'</b> 시 게시글이
              삭제되어 복원할 수 없습니다.
            </p>
          )}

          <MyTextField
            id="writerPassword"
            name="writerPassword"
            type="password"
            placeholder="비밀번호를 입력하세요."
            className="w-full max-w-[340px]"
          />

          <div>
            <p className="text-gray-dark text-sm text-center">
              비밀번호 분실 시 관리자에게 문의하여 주시길 바랍니다.
            </p>
            <p className="text-gray-dark text-sm font-semibold text-center">
              T. +82-2-3010-3390
            </p>
          </div>

          <div className="flex justify-center items-center gap-4">
            <MyButton onClick={closePopup}>
              {t("common.buttons.cancel")}
            </MyButton>
            <MyButton variant="contained" color="primary" type="submit">
              확인
            </MyButton>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default EnterWriterPasswordDialog;
